import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './../../styles/admin/referidos.css';
import * as globals from '../../components/GlobalScripts.js';

const Admin_referidos = () => {
    const [accounts, setAccounts] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const itemsPerPage = 10;

    const get_clients = (page = 1, search = '') => {
        globals.openViewCharge();
        axios.post(`${path_api}/update-clients/get_clients_referrer.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: page,
            itemsPerPage: itemsPerPage,
            search: search,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setAccounts(response.data.accounts);
                setTotalPages(response.data.totalPages);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvieron los clientes",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar los clientes",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        get_clients(currentPage, search);
    }, [currentPage]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearchChangeE = (e) => {
        get_clients(currentPage, e.target.value);
    };

    const handlePrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    return (
        <div className="page-referidos container-section flex-column gap-20">
            <h3>Listado de referidos</h3>
            <div className="container-search">
                <div className='search'>
                    <label>Filtra por correo:</label>
                    <input
                        type="text"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleSearchChangeE(e); }}
                        className="input-primary"
                        placeholder="Preciona enter para buscar"
                    />
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Correo electronico</th>
                        <th>Referente</th>
                    </tr>
                </thead>
                <tbody>
                    {accounts.map(account => (
                        <tr key={account.keylogin}>
                            <td>{account.email}</td>
                            <td>{account.referrer_email}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                    Anterior
                </button>
                <p>Página {currentPage} de {totalPages}</p>
                <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Admin_referidos;